import Vue from "vue";
import { ir } from "./check_domain_ir";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import mixins from "./mixins";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "./filters";
import { can } from "@/core/plugins/acl";
import lineClamp from "vue-line-clamp";

//Additional imports
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import DataTable from "laravel-vue-datatable";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import Toast from "vue-toastification";
import "@fortawesome/fontawesome-free/js/all.js";
import "vue-toastification/dist/index.css";
//Global Plugins
import GlobalComponents from "./globalComponents";
import $ from "jquery";
//MAP MATERIAL
import {
  LGeoJson,
  LMap,
  LMarker,
  LPopup,
  LTileLayer,
  LTooltip,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import JwtService from "@/core/services/jwt.service";
import jwtService from "@/core/services/jwt.service";
import mobileTable from "./core/plugins/mobileTable/src/install";
import customPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import { install as modalinstall } from "@/Utilities/ModalFunctions";
import { install as toastinstall } from "@/Utilities/ToastFunctions";
import modal from "@/core/plugins/EasyModal/index";
import Typed from "typed.js";

require("@erfanrhb/erfan-editor");

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-geojson", LGeoJson);
Vue.component("l-popup", LPopup);
Vue.component("l-tooltip", LTooltip);

Vue.use(CKEditor);
Vue.use(lineClamp);
Vue.use(mobileTable);
Vue.use(customPopup);

Vue.use(CKEditor);
Vue.use(VueSweetalert2);
// Vue.use(filters)

Vue.use(GlobalComponents);

Vue.use(modalinstall);

Vue.use(toastinstall);

Vue.config.productionTip = false;

window.axios = require("axios").create();

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.$ = $;
Vue.use(DataTable);
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
Vue.prototype.$coreLogin = ir(process.env.VUE_APP_LOGIN_URL);
Vue.prototype.$profileUrl = ir(process.env.VUE_APP_PROFILE_URL);
Vue.prototype.$smsUrl = ir(process.env.VUE_APP_PayamakLandURL);
Vue.prototype.$HomeUrl = ir(process.env.VUE_APP_HOME_URL);
Vue.prototype.$loginUrl = ir(process.env.VUE_APP_LOGIN_URL);
Vue.prototype.$terminalads_core = ir("https://core.terminalads.com");
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login");
Vue.prototype.$sarveLand = ir(process.env.VUE_APP_CoreLandUrl);
Vue.prototype.$payamakUrl = ir(process.env.VUE_APP_PAYAMAKLANDFRONT);
Vue.prototype.$robotLandFront = ir(process.env.VUE_APP_PROBOTLANDFRONT);
Vue.prototype.$requireLogin = process.env.VUE_APP_isLoginRequired;
Vue.prototype.$secret = process.env.VUE_APP_CoreSecret;
Vue.prototype.$uploadUrl = ir(process.env.VUE_APP_CoreLandUrl) + "/upload/";
Vue.prototype.$coreGraphicUrl = ir("https://core-graphic.terminalads.com");
Vue.prototype.$appApiUrl = ir(process.env.VUE_APP_API_URL);
Vue.prototype.$STATUS = {
  ACCEPT: "accept",
  DRAFT: "draft",
  PENDING: "pending",
  EDIT: "edit",
  DONE: "done",
};

Vue.prototype.$rules = {
  requiredString: [
    (val) => (val || "").length > 0 || "وارد کردن این فیلد الزامی میباشد.",
  ],
};

Vue.use(DataTable);

let dashboardConfig = {
  announcement: {
    img: Vue.prototype.$coreGraphicUrl + "/media/completed.png", // url
    text: "سفارش های تکمیلی", // any
    url: "",
  },
  numbers: {
    img: Vue.prototype.$coreGraphicUrl + "/media/saved.png",
    text: "سفارش های ثبت شده",
    url: "",
  },
  counter: new Promise((resolve) => {
    resolve({
      announcement: "-",
      numbers: "-",
    });
  }),
};

let static_top_menu = [];

Vue.use(TerminalTitleRibbon, {
  store, // this is vuex instance.
  axios,
  config: () => ({
    // global configs for layout & dashboard
    dashboardConfig, // dashboard data
    static_top_menu, // links in top of menu
    header_logo: Vue.prototype.$coreGraphicUrl + "/img/logo.a013c150.png", // set a getter in config.getters store
  }),
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"), // send Authorization with Bearer anytime.
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => window.Vue.$ability.j[0].actions, // this plugin need user permission for check user access.
  core_url: Vue.prototype.$sarveLand,
  front_url: Vue.prototype.$terminalads_core,
  sid: 14,
  server_id: 14, // this your service id, get one from core admin.
});

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
  maxToasts: 1,
  newestOnTop: true,
  color: "black",
});
Vue.component("date-picker", VuePersianDatetimePicker);

Vue.use(mixins);

Vue.use(modal);

window.fillSubheaderText = async function (texts) {
  let options = {
    strings: texts,
    loop: true,
    typeSpeed: 50,
  };

  let el = window.document.querySelector("#bishin");

  while (!el) {
    await setTimeout(() => {}, 500);
    el = window.document.querySelector("#bishin");
  }

  let typed = new Typed("#bishin", options);
};

window.Vue = new Vue({
  data() {
    return {
      Loaded: 0,
      LoadCount: 4,
    };
  },
  methods: {
    async fetch() {
      if (JwtService.getToken()) {
        try {
          // load abilities
          let response = await this.requestApiGetCore("abilitiesType");
          this.$ability.update([{ subject: "all", actions: response.data }]);
          this.addLoaded();
          // check tocken and load user information
          this.checkTokenAsync(jwtService.getToken()).then((res) => {
            this.addLoaded();
          });

          /// check wallet and load it
          this.checkWalletAsync().then((res) => {
            this.addLoaded();
          });

          //get menus
          this.getSpecialmenu().then((res) => {
            this.addLoaded();
          });
        } catch (e) {
          JwtService.destroyToken();
          window.location.replace(Vue.prototype.$loginUrl);
        }
      } else {
        window.location.replace(Vue.prototype.$loginUrl);
      }
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf("?");
      const end = url.indexOf("#");
      url = url.substring(start, end);
      let token = url.split("=")[0];
      let dataToken = url.split("=")[1];
      if (dataToken) {
        JwtService.saveToken(dataToken);
        // this.$store.commit('isAuthenticated', true);
        let fullUrl = document.URL;
        return window.history.pushState(
          "dashboard",
          "Title",
          "/" + fullUrl.substr(end)
        );
      }
    },
    addLoaded() {
      this.Loaded++;
      if (this.Loaded >= this.LoadCount) {
        this.$store.dispatch("global/isLoaded", true);
      }
    },
  },
  async beforeMount() {
    this.setToken();
    // await this.fetch();
    router.beforeResolve(async (to, from, next) => {
      window.Vue.$store.getters["global/isLoaded"] || (await this.fetch());
      if (to.meta.permission && !can(to.meta.permission)) {
        window.Vue.goto("dashboard");
      } else {
        this.setBreadcrumb(to.meta.title ?? "");
        next();
      }
    });
  },
  mounted() {
    if (localStorage.getItem("id_token"))
      window.Token = localStorage.getItem("id_token");
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
